import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, " ", -1)

import {reactive, ref} from "vue";
import {message} from "ant-design-vue";
import {PlusOutlined} from "@ant-design/icons-vue";
import {Rule} from "ant-design-vue/es/form";
import {IGroupConfigStepItem} from "@/app/editor/modules/group/v1";
import {IActivityGift} from "@/app/editor/types";
import GiftPickView from "@/app/editor/views/GiftPickView.vue";
import GiftItemView from "@/app/editor/views/GiftItemView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupProductsTableView',
  props: {
    items: {},
    isFail: { type: Boolean }
  },
  setup(__props: any) {


const props = __props

const info = reactive({
  items: props.items,
  item: {
    open: false,
    category: '组团优惠' as '组团优惠' | '未成团优惠',
    title: '',
    amount: 1,
    value: 0,
  },
  pick: {open: false, category: '全员福利' as '全员福利' | '团长福利' | '未成团优惠', gift: null as null | IActivityGift}
})

// 商品
const product = ref()
const productRules: Record<string, Rule[]> = {
  title: [{required: true, message: '名称必填'}],
  amount: [{
    validator: async (_r: unknown, v: number) => {
      if (v > 0) return Promise.resolve()
      else return Promise.reject('数量必填')
    }
  }],
  value: [{
    validator: async (_r: unknown, v: number) => {
      if (v > 0) return Promise.resolve()
      else return Promise.reject('数量必填')
    }
  }],
}

function onDelete(i: number) {
  info.items.splice(i, 1)
}

function addGroupItem() {
  product.value.validate().then((rs: IGroupConfigStepItem) => {
    info.items.push({
      category: info.item.category,
      amount: rs.amount,
      gift: null,
      title: rs.title,
      value: rs.value
    })
    cleanGroupItem()
  }).catch((err: unknown) => {
    console.log(err)
  })
}

function cleanGroupItem() {
  info.item.open = false
  info.item.title = ''
  info.item.value = 0
  info.item.amount = 1
}

// 礼品
const onPick = () => {
  if (info.pick.gift) {
    info.items.push({
      category: info.pick.category,
      amount: 1,
      gift: info.pick.gift,
      title: info.pick.gift.name,
      value: 0
    })

    info.pick.open = false
    info.pick.gift = null
  } else message.warn('没有选中礼品')
}

return (_ctx: any,_cache: any) => {
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_table_column_group = _resolveComponent("a-table-column-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_table, {
      "data-source": _ctx.items,
      bordered: "",
      pagination: false
    }, {
      summary: _withCtx(() => [
        _createVNode(_component_a_table_summary_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_table_summary_cell, { "col-span": 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, { gap: "middle" }, {
                  default: _withCtx(() => [
                    (!_ctx.isFail)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          disabled: _ctx.items.length>=10,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (info.item.open = true))
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 组团优惠 ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.isFail)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "primary",
                          disabled: _ctx.items.length>=10,
                          onClick: _cache[1] || (_cache[1] = () => {info.item.open = true; info.item.category='未成团优惠'})
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 未成团优惠 ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isFail)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          type: "primary",
                          disabled: _ctx.items.length>=10,
                          onClick: _cache[2] || (_cache[2] = () => {info.pick.open = true; info.pick.category='全员福利'})
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 全员福利 ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isFail)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 3,
                          type: "primary",
                          disabled: _ctx.items.length>=10,
                          onClick: _cache[3] || (_cache[3] = () => {info.pick.open = true; info.pick.category='团长福利'})
                        }, {
                          icon: _withCtx(() => [
                            _createVNode(_unref(PlusOutlined))
                          ]),
                          default: _withCtx(() => [
                            _createTextVNode(" 团长福利 ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      bodyCell: _withCtx(({ column, record, index }) => [
        (column.key==='category')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.category), 1)
            ], 64))
          : (column.key==='title')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (record.category == '组团优惠' || record.category == '未成团优惠')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(record.title) + _toDisplayString(`x${record.amount}`) + " 价值" + _toDisplayString(record.value) + "元 ", 1)
                    ], 64))
                  : (_openBlock(), _createBlock(GiftItemView, {
                      key: 1,
                      gift: record.gift
                    }, null, 8, ["gift"]))
              ], 64))
            : (column.key==='opt')
              ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                  key: 2,
                  title: "确定删除么？",
                  onConfirm: ($event: any) => (onDelete(index))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      danger: "",
                      type: "default"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"]))
              : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table_column_group, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isFail ? '未成团设置' : '优惠、福利设置'), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_table_column, {
              title: "类型",
              key: "category"
            }),
            _createVNode(_component_a_table_column, {
              title: "名称",
              key: "title"
            }),
            _createVNode(_component_a_table_column, {
              title: "操作",
              key: "opt"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_a_modal, {
      open: info.item.open,
      "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((info.item.open) = $event)),
      title: `添加${info.item.category}`,
      onOk: addGroupItem,
      onCancel: cleanGroupItem
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_form, {
          ref_key: "product",
          ref: product,
          model: info.item,
          rules: productRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "title",
              label: "名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: info.item.title,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((info.item.title) = $event)),
                  "allow-clear": "",
                  "show-count": "",
                  maxlength: 30
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "amount",
              label: "数量",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: info.item.amount,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((info.item.amount) = $event)),
                  max: 100
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "value",
              label: "总价值",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: info.item.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((info.item.value) = $event)),
                  max: 9999
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createVNode(_component_a_drawer, {
      open: info.pick.open,
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((info.pick.open) = $event)),
      title: "选择礼品",
      placement: "right",
      size: "large"
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_flex, { gap: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[8] || (_cache[8] = () => {info.pick.open=false; info.pick.gift = null})
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: onPick
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(GiftPickView, {
          gift: info.pick.gift,
          "onUpdate:gift": _cache[9] || (_cache[9] = ($event: any) => ((info.pick.gift) = $event))
        }, null, 8, ["gift"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})